import API from 'services/api';

const api = new API();

// Unwrap the shared `{status, value}` envelope: non-zero status rejects with the error payload.
const fetchValue = (url, options = {}) =>
    new Promise((resolve, reject) => {
        api.getJson(url, { credentials: 'include', ...options })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });

export const getReferenceTable = tableName =>
    fetchValue('/reference/api/get_table', { method: 'POST', params: { table_name: tableName } });

export const updateReferenceTable = (tableName, tableData) =>
    fetchValue('/reference/api/update_table', {
        method: 'POST',
        body: { table_name: tableName, table_data: JSON.stringify(tableData) },
    });

// Returns the raw envelope so the caller can read `rows_processed` on success or `error` on failure,
// mirroring the legacy upload flow.
export const uploadReferenceTableCsv = (file, tableName) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('table_name', tableName);
    return api.getJson('/reference/api/upload', { method: 'POST', body: formData, credentials: 'include' });
};

// The dictionaries that back the autocomplete columns. Each endpoint returns `{status, value: [...]}`.
const getApps = () => fetchValue('/api/users/self/apps');
const getOperatingSystems = () => fetchValue('/api/os');
const getAccounts = () => fetchValue('/api/account');
const getDevices = () => fetchValue('/api/devices');
const getAdNetworks = () => fetchValue('/api/users/self/adns');
const getCurrencies = () => fetchValue('/api/currencies');
const getCountries = () => fetchValue('/api/countries');

// Fetch every dictionary in parallel and shape them into the per-field map the grid validates
// against. Ad networks feed both the source and sub-ad-network columns; currencies feed the two
// original-currency columns and the optional value-currency column.
export const getDictionaries = () =>
    Promise.all([
        getApps(),
        getOperatingSystems(),
        getAccounts(),
        getDevices(),
        getAdNetworks(),
        getCurrencies(),
        getCountries(),
    ]).then(([apps, operatingSystems, accounts, devices, adNetworks, currencies, countries]) => {
        const adNetworkOptions = adNetworks.map(adn => ({ name: adn.name, display_name: adn.display_name }));
        return {
            app: apps,
            os: operatingSystems,
            device: devices,
            source: adNetworkOptions,
            sub_adnetwork: adNetworkOptions,
            country: countries,
            adn_account_id: accounts,
            adn_original_currency: currencies,
            tracker_original_currency: currencies,
            value_currency: currencies,
        };
    });
